import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, catchError, of, debounceTime } from 'rxjs';

import { SystemService } from '@offconon/core-api';

import * as LanguageDropdownActions from './language-dropdown.actions';

@Injectable()
export class LanguageDropdownEffects {
  private actions$ = inject(Actions);
  public systemService = inject(SystemService);
  private store = inject(Store);

  fetchLanguages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LanguageDropdownActions.fetchLanguages),
      debounceTime(300),

      switchMap((action) => {
        return this.systemService
          .systemLanguagesList(action.page, action.pageSize, action.searchJson)
          .pipe(
            switchMap((languageResponse) => {
              return of(
                LanguageDropdownActions.fetchLanguagesSuccess({
                  languageResponse,
                  dropdownId: action.dropdownId,
                }),
              );
            }),
            catchError((error) =>
              of(LanguageDropdownActions.loadLanguageDropdownFailure({ error })),
            ),
          );
      }),
    ),
  );

  searchLanguages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LanguageDropdownActions.searchLanguage),
      debounceTime(500),
      switchMap((action) => {
        return this.systemService.systemLanguagesList(1, 50, action.searchJson).pipe(
          switchMap((languageResponse) => {
            return of(
              LanguageDropdownActions.fetchLanguagesSuccess({
                languageResponse,
                dropdownId: action.dropdownId,
              }),
            );
          }),
          catchError((error) => of(LanguageDropdownActions.loadLanguageDropdownFailure({ error }))),
        );
      }),
    ),
  );
}
